module.exports = __webpack_public_path__ + "static/img/rsms.d402e5c8.png";